import { useEffect, useState } from 'react'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { useAbTest, useTrackAbTestCallback } from '@marketplace-web/feature-flags/ab-tests-data'
import {
  getBumpAgainSuggestion,
  getBumpAgainSuggestionSvcVas,
  transformBumpAgainSuggestionResponse,
} from '@marketplace-web/vas/vas-data'
import {
  usePromoAfterItemUploadContext,
  PromoAfterItemUpload,
} from '@marketplace-web/item-upload/after-upload-actions-feature'

import {
  getIsBumpAgainSuggestionSeen,
  setBumpAgainSuggestionAsSeen,
} from '../../../utils/bumpAgainSuggestionCap'

const useFetchBumpAgainSuggestion = () => {
  const isBumpAgainSuggestionSeen = getIsBumpAgainSuggestionSeen()
  const trackExpose = useTrackAbTestCallback()
  const vasApiGatewaySwapBumpAgainSuggestionAbTest = useAbTest(
    'vas_api_gateway_swap_bump_again_suggestion',
  )
  const isVasApiGatewaySwapBumpAgainSuggestionAbTestOn =
    vasApiGatewaySwapBumpAgainSuggestionAbTest?.variant === 'on'

  const { fetch: fetchBumpAgainSuggestionCore, transformedData: bumpAgainSuggestionDataCore } =
    useFetch(getBumpAgainSuggestion, transformBumpAgainSuggestionResponse)

  const { fetch: fetchBumpAgainSuggestionSvcVas, transformedData: bumpAgainSuggestionDataSvcVas } =
    useFetch(getBumpAgainSuggestionSvcVas, transformBumpAgainSuggestionResponse)

  const bumpAgainSuggestionData = isVasApiGatewaySwapBumpAgainSuggestionAbTestOn
    ? bumpAgainSuggestionDataSvcVas
    : bumpAgainSuggestionDataCore
  const fetchBumpAgainSuggestion = isVasApiGatewaySwapBumpAgainSuggestionAbTestOn
    ? fetchBumpAgainSuggestionSvcVas
    : fetchBumpAgainSuggestionCore

  const { currentPromotion } = usePromoAfterItemUploadContext()

  const [isPromoAfterItemUploadShown, setIsPromoAfterItemUploadShown] = useState(false)

  useEffect(
    function checkPromoAfterItemUpload() {
      if (!currentPromotion) return
      if (currentPromotion === PromoAfterItemUpload.Empty) return

      setIsPromoAfterItemUploadShown(true)
    },
    [currentPromotion],
  )

  useEffect(
    function fetchData() {
      if (isBumpAgainSuggestionSeen) return
      if (isPromoAfterItemUploadShown) return
      if (currentPromotion !== PromoAfterItemUpload.Empty) return

      fetchBumpAgainSuggestion()
      trackExpose(vasApiGatewaySwapBumpAgainSuggestionAbTest)
    },
    [
      isBumpAgainSuggestionSeen,
      currentPromotion,
      isPromoAfterItemUploadShown,
      fetchBumpAgainSuggestion,
      trackExpose,
      vasApiGatewaySwapBumpAgainSuggestionAbTest,
    ],
  )

  useEffect(
    function registerBumpAgainSuggestionAsSeen() {
      if (!bumpAgainSuggestionData?.bumpAgainSuggestion) return

      setBumpAgainSuggestionAsSeen()
    },
    [bumpAgainSuggestionData],
  )

  return {
    showBumpAgainSuggestion: !!bumpAgainSuggestionData?.bumpAgainSuggestion,
    soldItemId: bumpAgainSuggestionData?.bumpAgainSuggestion?.soldItemId,
  }
}

export default useFetchBumpAgainSuggestion
